const CALENDAR_ACTIONS = {
  //User Shift Type
  GET_USER_SHIFT_TYPES_REQUEST: "GET_USER_SHIFT_TYPES_REQUEST",
  GET_USER_SHIFT_TYPES_SUCCESS: "GET_USER_SHIFT_TYPES_SUCCESS",
  GET_USER_SHIFT_TYPES_FAIL: "GET_USER_SHIFT_TYPES_FAIL",
  // request Export CSV
  EXPORT_CSV_REQUEST: "EXPORT_CSV_REQUEST",
  EXPORT_CSV_SUCCESS: "EXPORT_CSV_SUCCESS",
  EXPORT_CSV_FAIL: "EXPORT_CSV_FAIL",
};
export default CALENDAR_ACTIONS;
